module.exports = __webpack_public_path__ + "static/img/users.f06243e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/users.svg
// module id = FocJ
// module chunks = 1